import React from 'react'
import Section2 from './section2';
import Section3 from './section3';
import Section4 from './section4';
import About from './about';
import Footer from './section5';
import DarkVariantExample from './testmonial';

export default function Home() {
  return (
    <>
         
        <Section2 />
        <Section3 />
        <Section4 />
        <About />
        <DarkVariantExample />
        <Footer />
    </>
  )
}
